import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withTranslation, useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { getBaseName } from '../common/Utils';
import moment from 'moment';

class ConsultationResponse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            item: null
        };
    }

    async loadData() {
        const lang = this.props.match.params.lang;

        const apiParams = new URLSearchParams({
            refNo: this.props.refNo,
            lang: lang
        });
        const apiUrl = `${getBaseName()}/api/consultation/response?${apiParams.toString()}`;

        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {            
            const response = await fetch(apiUrl,options);
            if (response.status === 200) {
                const result = await response.json();

                console.log(result);

                this.setState({
                    item: result
                });
            } else {
                this.props.history.push(`/gateway/${lang}/error`);     
            }
        } catch (error) {
            console.log(error);
        }

    }

    componentDidMount() {
        this.loadData();

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }

    }

    render() {
        const { t } = this.props;
        const { item } = this.state;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;

        if (item === null) {
            return (
                <div>Loading Consultation Response...</div>
            );
        } else {
            const categoryTitles = [];
            const categoryTables = [];

            if (item.archived) {
                categoryTitles.push(
                    <li>{t("response.category.C.desc")}</li>
                );
                categoryTitles.push(
                    <li>{t("response.category.D.desc")}</li>
                );

                categoryTables.push(<br/>);
                categoryTables.push(<CategoryCTable item={item}/>);
                categoryTables.push(<br/>);
                categoryTables.push(<CategoryDTable item={item}/>);
            }
            return (
                <div>
                    <Helmet>
                        <title>{t("response.title")} | {t('common:sfc')}</title>
                        <meta name='date' content={t('common:date.metaformatter',{date:moment(item.modificationTime, "YYYY-MM-DDTHH:mm:ss").toDate()})}></meta>
                        <script>{gaScript}</script>
                        <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                        <script>{ga4Script}</script>
                    </Helmet>
                    <h1>{item.cpTitle}</h1>
                    <ul>
                        <li>{t("response.category.A.desc")}</li>
                        <li>{t("response.category.B.desc")}</li>
                        {categoryTitles}
                    </ul>
                    <br/>
                    <CategoryATable item={item}/>
                    <br/>
                    <CategoryBTable item={item}/>
                    {categoryTables}

                    <ConclusionFigures item={item}/>
                    <br/>
                    <p>{t("response.label.lastUpdateDate",{date: moment(item.modificationTime, "YYYY-MM-DDTHH:mm:ss").toDate()})}</p>
                </div>
            );
        }
    }
}

function CategoryATable(props) {
    const { t } = useTranslation();
    const { item } = props;
    const { catAResponseList: list } = item;

    return (
        <div className="table-container main-style consultation-response-category-table">
            <h3>{t('response.category.A.title')}</h3>
            <table>
                <tbody>
                    <tr>
                        <td>{t('response.table.header.date')}</td>
                        <td>{t('response.table.header.name')}</td>
                    </tr>
                </tbody>
                {(list.map((comment) =>
                    <tr key={comment.commentRefNo}>
                        <td>
                            <Link to={`openCommentFile?refNo=${item.cpRefNo}&commentRefNo=${comment.commentRefNo}`} target="_blank">
                                {t('common:date.formatter',{date: moment(comment.receivedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                            </Link>
                        </td>
                        <td>{comment.respondentName}</td>
                    </tr>
                ))}
            </table>
        </div>
    );
}

function CategoryBTable(props) {
    const { t } = useTranslation();
    const { item } = props;
    const { catBResponseList: list } = item;

    return (
        <div className="table-container main-style consultation-response-category-table">
            <h3>{t('response.category.B.title')}</h3>
            <table>
                <tbody>
                    <tr>
                        <td>{t('response.table.header.date')}</td>
                        <td>{t('response.table.header.name')}</td>
                    </tr>
                </tbody>
                {(list.map((comment) =>
                    <tr key={comment.commentRefNo}>
                        <td>
                            <Link to={`openCommentFile?refNo=${item.cpRefNo}&commentRefNo=${comment.commentRefNo}`} target="_blank">
                                {t('common:date.formatter',{date: moment(comment.receivedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                            </Link>
                        </td>
                        <td>{t('response.category.B.respondent',{i: comment.rownum})}</td>
                    </tr>
                ))}
            </table>
        </div>
    );
}

function CategoryCTable(props) {
    const { t } = useTranslation();
    const { item } = props;

    return (
        <div>
            <h3>{t('response.category.C.title')}</h3>
            <p>{t('response.category.C.totalNumberOfCategoryCRespondent',{ cnt: item.unpublishedAnonymousCommentCount})}</p>
        </div>
    );
}

function CategoryDTable(props) {
    const { t } = useTranslation();
    const { item } = props;
    const { catDResponseList: list } = item;

    return (
        <div className="table-container main-style consultation-response-category-table">
            <h3>{t('response.category.D.title')}</h3>
            <table>
                <tbody>
                    <tr>
                        <td>{t('response.table.header.date')}</td>
                        <td>{t('response.table.header.name')}</td>
                    </tr>
                </tbody>
                {(list.map((comment) =>
                    <tr key={comment.commentRefNo}>
                        <td>
                            {t('common:date.formatter',{date: moment(comment.receivedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                        </td>
                        <td>{comment.respondentName}</td>
                    </tr>
                ))}
            </table>
        </div>
    );
}

function ConclusionFigures(props) {
    const { t } = useTranslation();
    const { item } = props;

    if (item.hasConclusion) {
        return (            
            <div>
                <p>
                    <br/>
                    {t('response.label.totalNumberOfCommentReceived',{ cnt: item.receivedCommentCount})}
                    <br/>
                    {t('response.label.totalNumberOfAnonymousCommentReceived',{ cnt: item.anonymousCommentCount})}
                </p>
            </div>
        );
    } else {
        return [];
    }
}

export default withRouter(withTranslation()(ConsultationResponse));
